import {useMemo} from 'react';

import {
  type EntityIntegrationsQuery,
  type EntityQuery,
  type SlackIntegration as Slack,
} from '../../generated/graphql';
import {type Entity} from '../../types/graphql';
import {isSlackIntegration} from './utils';

export function useSlackIntegrationsFromEntity(
  entity: Entity | EntityQuery['entity'] | EntityIntegrationsQuery['entity']
) {
  return useMemo(() => {
    const slackIntegrations: Slack[] = [];
    for (const integrationEdge of entity?.integrations?.edges ?? []) {
      if (integrationEdge?.node) {
        const integration = integrationEdge.node;
        if (isSlackIntegration(integration)) {
          slackIntegrations.push(integration);
        }
      }
    }
    return slackIntegrations;
  }, [entity?.integrations?.edges]);
}
